export const saveSettingUrl = "/api/v3/share_settings";
